"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var multi_product_carousel_1 = require("../../utils/shopify-graphql/multi-product-carousel");
var path_1 = require("../../utils/shopify/path");
var MultiProductCarouselMain_1 = require("./MultiProductCarouselMain");
var MultiProductCarouselUro_1 = require("./MultiProductCarouselUro");
var MultiProductCarousel = function () {
    var _a = (0, hooks_1.useState)(null), products = _a[0], setProducts = _a[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, multi_product_carousel_1.getProductCarouselData)(handle, pathType).then(function (data) {
            if (data) {
                setProducts(data);
            }
        });
    }, []);
    //ensure reviews and color retrieved then show Swiper, otherwise it will be visually broken
    if (products && products.length >= 1) {
        return ((0, preact_1.h)("div", null, location.pathname == '/collections/uro' ? ((0, preact_1.h)(MultiProductCarouselUro_1.default, { prodList: products })) : ((0, preact_1.h)(MultiProductCarouselMain_1.default, { prodList: products }))));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = MultiProductCarousel;
